import React from 'react';

const BankTransfer = () => {
  return (
    <div className="mt-4">
      <p className="font-bold mt-4">Our Bank details for fund transfer</p>

      <div className="bg-cf-200 rounded p-4 text-left my-4">
        <div className="flex justify-between">
          <span className="font-header text-sm">Bank Name:</span>
          <span className="text-xs">ABSA </span>
        </div>
        <div className="flex justify-between">
          <span className="font-header text-sm">Branch:</span>
          <span className="text-sm">HIGH STREET</span>
        </div>
        <div className="flex justify-between">
          <span className="font-header text-sm">Swift Code:</span>
          <span className="text-sm">BARCGHAC</span>
        </div>
        <div className="flex justify-between">
          <span className="font-header text-sm">Account Name:</span>
          <span className="text-sm">Complete Farmer Limited</span>
        </div>
        <div className="flex justify-between">
          <span className="font-header text-sm">Account Number (GHS):</span>
          <span className="text-sm">0481113385</span>
        </div>
        <div className="flex justify-between">
          <span className="font-header text-sm">Account Number (USD):</span>
          <span className="text-sm">0641409553</span>
        </div>
      </div>

      <p className="font-bold mt-4">Payment Via Transferwise</p>

      <div className="bg-cf-200 rounded p-4 text-left my-4">
        <div className="flex justify-between">
          <span className="font-header text-sm">Account Number:</span>
          <span className="text-sm">2161080126220</span>
        </div>

        <div className="flex justify-between">
          <span className="font-header text-sm">Bank branch:</span>
          <span className="text-sm">Head Office [230101]</span>
        </div>
      </div>

      <div className="bg-cf-200 rounded p-4 text-left my-4 text-sm">
        <p>
          Please note that bank transfers can take up to 2 weeks before reflecting in our account.
          Once payment is made, kindly send a copy of your payment slip to our experienced customer
          support. They will provide you with a payment confirmation notice once payment is
          received.
        </p>
      </div>
    </div>
  );
};

export default BankTransfer;
